import { 
	ifAuthenticated, 
	ifNotAuthenticated, 
	ifAuthenticatedOnline,
	canAccess,
	AppTabs,
	Edit,
	Create,
	Show,
	Crud,
	trans
} from '@/router/index'

import Role from '@/components/modules/users/Role'
import RoleEditor from '@/components/modules/users/RoleEditor'
import UsersOptions from '@/components/modules/users/settings/UsersOptions'
import RolesOptions from '@/components/modules/users/settings/RolesOptions'

export const users = [

	/**********************************************************************************
	*
	* @USERS 
	*
	***********************************************************************************/
	{ 
		path: '/users',
		beforeEnter: ifAuthenticated,
		component: AppTabs, 
		props: {
			tabs: [
				{
					to: '/users/',
					text: trans('users'),
				},
				{
					to: '/users/groups',
					text: 'Gruppi',
					model: 'group'					
				},
				{
					to: '/users/roles',
					text: 'Ruoli',
					model: 'role'					
				},			
			],
		},
		children: [
			{
				path: '/users/',
				name: 'users-index',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: trans('users')
				},
				props: {
					modelDef: 'users',
					actionIcon: 'group',
					title: trans('users'),
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/users/groups',
				name: 'groups-index',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: trans('groups')
				},
				props: {
					modelDef: 'groups',
					actionIcon: 'mdi-account-group',
					title: trans('groups'),
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/users/roles',
				name: 'roles-index',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: trans('roles')
				},
				props: {
					modelDef: 'roles',
					actionIcon: 'mdi-lock',
					title: trans('roles'),
					styleClass: 'mb-offset'
				}
			},			
		],
	},
	{ 
		path: '/users/create',
		name: 'users-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'users',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/users/:id/edit',
		name: 'users-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'users',
			id:  parseInt(route.params.id),
		}),
	},
	{ 
		path: '/users/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/users/' + parseInt(route.params.id) + '/',
					text: 'Utente',
				},
				{
					to: '/users/' + parseInt(route.params.id) + '/audits',
					text: 'Audit',
				},
			]
		}),
		children: [
			{
				path: '',
				name: 'users-show', 
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'user', next) },
				component: Show,
				meta: {
					title: 'Utente'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'users',
					modelClass: 'user',
					activities: true
				}),
			},
			{
				path: '/users/:id/audits',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'user', next) },
				component: Crud,
				meta: {
					title: trans('audits')
				},
				props: (route) => ({
					modelDef: 'audits',
					actionIcon: 'mdi-account-group',
					title: trans('audits'),
					styleClass: 'mb-offset',
					subFilters: {users: parseInt(route.params.id)}
				}),
			},
		]
	},
	/**********************************************************************************
	*
	* @GROUPS 
	*
	***********************************************************************************/
	{ 
		path: '/users/groups/create',
		name: 'groups-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'groups',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/users/groups/:id/edit',
		name: 'groups-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'groups',
			id:  parseInt(route.params.id),
		}),
	},
	{ 
		path: '/users/groups/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/users/groups/' + parseInt(route.params.id) + '/',
					text: 'Gruppo',
				},			
			]
		}),
		children: [
			{
				path: '',
				name: 'groups-show', 
				beforeEnter: (to, from, next) => canAccess('permission', 'group', next),
				component: Show,
				meta: {
					title: 'Gruppo'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'groups',
					modelClass: 'group',
					activities: true
				}),
			},
		]
	},
	{ 
		path: '/settingsusers/',
		name: 'settingsusers',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsusers',
					text: 'Utenti',
				},
			],
		},
		children: [
			{
				path: '/settingsusers/',
				beforeEnter: ifAuthenticatedOnline,
				component: UsersOptions,
			},
		],
	},


	/**********************************************************************************
	*																					
	* @ROLES
	*
	***********************************************************************************/
	{ 
		path: '/roles/create',
		name: 'roles-create',
		beforeEnter: ifAuthenticatedOnline,
		component: RoleEditor,
		props: (route) => ({
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),		
	},
	{ 
		path: '/roles/:id/edit',
		name: 'roles-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: RoleEditor,
		props: (route) => ({
			id:  parseInt(route.params.id),
		}),
	},
	{ 
		path: '/roles/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/roles/' + parseInt(route.params.id) + '/',
					text: 'Ruolo',
				},			
			]
		}),
		children: [
			{
				path: '',
				name: 'roles-show', 
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'role', next) },
				component: Role,
				meta: {
					title: 'Ruolo'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
				}),
			},
		]		
	},
	{ 
		path: '/settingsroles/',
		name: 'settingsroles',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsroles',
					text: 'Ruoli',
				},
			],
		},
		children: [
			{
				path: '/settingsroles/',
				component: RolesOptions,
			},
		],
	},
]